import { Component, OnInit, ViewChild } from '@angular/core';
import { Persona } from '@app/persona/models';
import { Observable, Subject } from 'rxjs';
import { NzSelectComponent } from 'ng-zorro-antd/select';
import { PersonaListComponent } from '@app/persona/containers/persona-list/persona-list.component';
import { PersonaUI, personaUIComparator, toPersonaUI } from '@app/persona/containers/persona-list/persona-map';
import { map, tap, withLatestFrom } from 'rxjs/operators';
import { PersonaPickerService } from '@app/persona/services/persona-picker.service';
import { PersonaUITypes } from '@app/persona/constants/constants';

@Component({
    selector: 'app-persona-picker-modal',
    templateUrl: './persona-picker-modal.component.html',
    styleUrls: ['./persona-picker-modal.component.scss']
})
export class PersonaPickerModalComponent implements OnInit {

    @ViewChild(PersonaListComponent, { static: false }) personaList: PersonaListComponent;

    modalTitle = 'Select a testing catalogue';
    isModalVisible = false;
    showList = true;

    selectedPersonaUI$: Observable<PersonaUI>;
    hasToSelectPersona$: Observable<boolean>;
    confirm$ = new Subject<void>();

    comparator() {
        return personaUIComparator;
    }

    getSelectedPersonaUI$() {
        return this.personaPicker.selectedPersona$.pipe(
            map(persona => !!persona ? toPersonaUI(persona) : null)
        );
    }

    getConfirm$(toSelectPersona$: Observable<Persona>) {
        return this.confirm$.pipe(
            withLatestFrom(toSelectPersona$),
            tap(([_, personaToSet]) => {
                this.personaPicker.setPersona(personaToSet);
            })
        );
    }

    onConfirm() {
        this.confirm$.next();
        this.isModalVisible = false;
    }

    onCancel() {
        this.personaList.reset();
        this.isModalVisible = false;
    }

    onSelectClick(select: NzSelectComponent) {
        select.blur();
        this.showList = true;
        this.isModalVisible = true;
    }

    onSelect(id: string) {
        this.personaPicker.setToSelectPersona(id);
        setTimeout(() => this.onConfirm());
    }

    isTypePersona(type: PersonaUITypes) {
        return type === PersonaUITypes.PERSONA;
    }

    constructor(
        private personaPicker: PersonaPickerService
    ) {
    }

    ngOnInit() {
        this.selectedPersonaUI$ = this.getSelectedPersonaUI$();
        this.hasToSelectPersona$ = this.personaPicker.hasToSelectPersona$;
        this.getConfirm$(this.personaPicker.toSelectPersona$).subscribe();
    }

}
